import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './midcontent.scss';
import '../Landingpage/Landingpage.scss';

const CategoryList = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchCategories = async () => {
        try {
            const response = await fetch('https://backend.indianjewelryish.com/api/category');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setCategories(data.category);
            setError(null);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    if (loading) return <p>Loading categories...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className="container">
            <div className="row" style={{ 'width': "100%" }}>
                <div className="col-sm-12" style={{ 'width': "100%" }}>
                    <h3 className="text-center mt-4 ml-4 landing-heading">CATEGORIES</h3>
                </div>
            </div>
            <div className="row mt-0">
                <div className="col-sm-12">
                    <section id='midcontent'>

                        {categories.map((category) => (

                            <div key={category.id} class="card" style={{ "height": "100%", "minHeight": "230px" }}>
                                <Link to={`/category?category=${category.category_code}`}>
                                    <div className='image-container'>
                                        <img
                                            src={`https://backend.indianjewelryish.com/${category.category_image}`}

                                            alt={category.category_name}
                                        />
                                    </div>
                                    <h3 className='pt-2 px-2 pb-2' style={{ "font-size": "16px" }}>{category.category_name}</h3>

                                </Link>
                            </div>
                        ))}

                    </section>
                </div>
            </div>
        </div>

    );
};

export default CategoryList;
